import type { ReactNode } from "react";
import { EmptyState } from "@cntrl/ui";
import { useBandContextOrNull } from "./bandContext.js";

/**
 * Gate for a band-scoped route. Every band-scoped module mounts ONLY under a resolved BandProvider
 * in the shell's zero-band (org-home) state the routed module renders without one, so a
 * band-scoped route deep-linked by a person with no band seat (born-blank / all seats revoked) would
 * otherwise hit the throwing <c>useBandContext()</c>. This renders a designed state there instead of a
 * framework crash — the client half of the born-blank contract for these routes.
 */
export function RequireBand({ children }: { children: ReactNode }) {
  const band = useBandContextOrNull();
  if (!band) {
    return (
      <EmptyState
        title="No band selected"
        description="Choose a band from the switcher to open this."
      />
    );
  }
  return <>{children}</>;
}
